module.exports = __webpack_public_path__ + "img/1570685197.bfd7c1d6.jpg";